import React, { useState, useEffect } from "react";
//import "./styles/common.css"; // make sure it's styled correctly

function MatchTimer({ matchId, socket }) {
    const [elapsedTime, setElapsedTime] = useState(0);
    const [timerPaused, setTimerPaused] = useState(true);

    useEffect(() => {
        if (socket) {
            socket.on("timerUpdate", (data) => {
                if (data.matchId === matchId) {
                    setElapsedTime(data.elapsedTime);
                    setTimerPaused(data.timerPaused ?? false);
                }
            });

            return () => {
                socket.off("timerUpdate");
            };
        }
    }, [socket, matchId]);

    const startTimer = () => {
        socket.emit("startMatchTimer", { matchId });
    };

    const pauseTimer = () => {
        socket.emit("timerPause", { matchId });
    };

    const resumeTimer = () => {
        socket.emit("resumeTimer", { matchId });
    };

    const formattedTime = 
        !isNaN(elapsedTime) && elapsedTime >= 0 
            ? new Date(elapsedTime * 1000).toISOString().substr(14, 5) 
            : "00:00";

    return (
        <span className="match-timer-wrapper">
            <span className="timer">⏱ {formattedTime}</span>
            </span>
    );
}

export default MatchTimer;
